/* eslint-disable import/prefer-default-export */

export enum BucketedInteractionsTransformerStrategy {
  CATEGORY = 'category',
  PORTFOLIO = 'portfolio',
  CUSTOM_SINGLE_SELECT = 'customSingleSelect',
  CUSTOM_ENTITY = 'customEntity',
}
